/* eslint-disable camelcase */
import { addTimestamp, archives, publicArchives } from '@saucelabs/sl-util-axios';

type JobStatus = 'passed' | 'failed' | 'error' | 'complete' | 'in progress' | 'queued';

type RunMode = 'automatic' | 'manual' | 'scheduled' | 'ondemand';

type Cloud = 'vdc' | 'rdc';

interface ArchivesJobsParams {
  startDate?: number,
  endDate?: number,
  page?: number,
  size?: number,
  status: JobStatus[],
  build_name?: string[],
  device?: string[],
  os?: string[],
  browser?: string[],
  ownerID?: string[],
  teamID?: string[],
  runMode?: RunMode[],
  cloud: Cloud,
  isOpenSauceUser: boolean,
  username: string,
  name_match?: string,
  tag?: string[],
}

export function getArchivedJobs(params: ArchivesJobsParams): Promise<any> {
  const {
    isOpenSauceUser,
    username,
    cloud,
    build_name,
    os = [],
    browser = [],
    startDate: start_date,
    endDate: end_date,
    ownerID: owner_id,
    teamID: team_id,
    runMode: run_mode,
    ...rest
  } = params;

  if (isOpenSauceUser) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return publicArchives.get(
      '/jobs',
      addTimestamp({
        params: {
          ...rest,
          username,
        },
      }),
    );
  }

  // NOTE: api expects os name and version to be delimited with '__' but all
  // other spaces are simply encoded. e.g. macOS Big Sur -> macOS__Big%20Sur
  const normalizedOS = os.map((item) => item.replace(' ', '__'));
  const normalizedBrowser = browser.map((item) => item.replace(' ', '__'));

  return archives.get(
    `/${cloud}/jobs`,
    addTimestamp({
      params: {
        build_name,
        start_date,
        end_date,
        owner_id,
        team_id,
        run_mode,
        os: normalizedOS,
        browser: normalizedBrowser,
        ...rest,
      },
    }),
  );
}
